import EmailConfirm from './EmailConfirm';

export default EmailConfirm;
